import 'isomorphic-fetch';
import { VehicleInformation } from '../typings/general';

interface FetchVehicleInformationProps {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly vin?: string;
}

export const fetchVehicleInformation = async ({
  faServicesUrl,
  apiKey,
  vin,
}: FetchVehicleInformationProps): Promise<VehicleInformation> => {
  const params = new URLSearchParams();

  if (vin) params.set('vin', vin);

  const url: string = `${faServicesUrl}/maintenance/vehicleinformation?${params.toString()}`;

  const response = await fetch(url, {
    headers: { 'x-api-key': apiKey }
  });

  if (response.status >= 400) {
    throw new Error(`Failed to fetch vehicle information: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data;
}